module.exports = __webpack_public_path__ + "static/media/co.03db6da5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/co.svg
// module id = 2068
// module chunks = 0